import { useEffect, useState } from "react";
import { columnVisibilityItems } from "./components/columnVisibilityItems";
import { connect } from "react-redux";
import { TableColumns } from "./components/TableColumns";
import { fetchDcddActiveUsers } from "modules/user_management/dcdd_user/users/state/action";
import ServerTable from "components/table/ServerTable";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;
const DcddActiveUserTable: React.FC<Props> = ({
  fetchDcddUsers,
  onFetchDcddActiveUsers,
  // onResetDcddData
}) => {
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0)
  const [hasNext] = useState(true);
  const [pageIndex, setPageIndex] = useState(0)
  const dcddActiveUserData = fetchDcddUsers?.dcddActiveUsers?.grouped_user_activities;
  useEffect(() => {
    onFetchDcddActiveUsers(limit, offset)
  }, [onFetchDcddActiveUsers, limit, offset]);
  
  const handlePaginationChange = (newLimit: number, newOffset: number) => {
    const newPageIndex = Math.floor(newOffset / newLimit);
    setLimit(newLimit);
    setOffset(newOffset);
    setPageIndex(newPageIndex);
    onFetchDcddActiveUsers(newLimit, newOffset);
  };
  const downloadExcel = (data: any[]) => {
    if (!data || data.length === 0) return;

    const headers = Object.keys(data[0]);
    const rows = data
      .map(
        (row) =>
          `<tr>${headers
            .map((field) => `<td>${row[field] ?? ""}</td>`)
            .join("")}</tr>`
      )
      .join("");

    const tableHTML = `
    <table>
      <thead><tr>${headers.map((h) => `<th>${h}</th>`).join("")}</tr></thead>
      <tbody>${rows}</tbody>
    </table>`;

    const blob = new Blob(
      [
        `\uFEFF<html><head><meta charset="UTF-8"></head><body>${tableHTML}</body></html>`,
      ],
      { type: "application/vnd.ms-excel" }
    );

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "dcdd_users.xls";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <ServerTable
        headers={["Report", "Dcdd Active Users"]}
        data={dcddActiveUserData}
        columnVisibilityItems={columnVisibilityItems}
        tableColumns={TableColumns}
        addButton={<div>
          <button
            className="border px-3 py-2 bg-primary-500 mx-2 rounded-md hover:bg-primary-800 text-primary-100 hover:text-white hover:shadow-md"
            onClick={() => downloadExcel(dcddActiveUserData)}
          >
            Download Excel
          </button>
        </div>}
        onPaginationChange={handlePaginationChange}
        pageIndex={pageIndex}
        pageSize={limit}
        hasNext={hasNext}
      />
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    fetchDcddUsers: state.dcddUser.dcddUserState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchDcddActiveUsers: (limit: number, offset: number) => dispatch(fetchDcddActiveUsers(limit, offset)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DcddActiveUserTable);
